<script lang="ts">
    export let size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = null
    export let sizeM: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = null
    export let flex = false
    export let verticalAlign: 'start' | 'center' | 'end' = null
    export let horizontalAlign: 'start' | 'center' | 'end' = null
    export let width: string = ''
</script>

<div
    class="z-container-col z-col z-col_w-{size} z-col-m_w-{sizeM}"
    style={(flex ? 'display:flex;' : '') +
        (verticalAlign ? 'align-items:' + verticalAlign + ';' : '') +
        (horizontalAlign ? 'justify-content:' + horizontalAlign + ';' : '') +
        (width ? 'max-width:' + width + ';width:' + width + ';' : '')}
>
    <slot></slot>
</div>
